import { motion } from 'framer-motion';
import { useEffect } from 'react';

const ProfileUpdateSuccess = ({ show, onClose, type = 'profile' }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  const getMessage = () => {
    switch (type) {
      case 'profile':
        return 'Profile updated successfully! Changes are now visible in the header.';
      case 'password':
        return 'Password changed successfully! Please use your new password for future logins.';
      case 'photo':
        return 'Profile photo updated successfully! Your new photo is now visible.';
      default:
        return 'Update successful!';
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'profile':
        return 'fa-user-check';
      case 'password':
        return 'fa-key';
      case 'photo':
        return 'fa-camera';
      default:
        return 'fa-check';
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -50, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -50, scale: 0.9 }}
      className="fixed top-32 right-4 z-50 bg-green-500 text-white px-6 py-4 rounded-lg shadow-lg flex items-center space-x-3 min-w-[350px] max-w-[500px]"
    >
      <motion.i 
        className={`fas ${getIcon()} text-lg`}
        animate={{ rotate: [0, 360] }}
        transition={{ duration: 0.5 }}
      />
      <span className="flex-1">{getMessage()}</span>
      <button
        onClick={onClose}
        className="text-white hover:text-gray-200 transition-colors"
      >
        <i className="fas fa-times"></i>
      </button>
    </motion.div>
  );
};

export default ProfileUpdateSuccess;